import { render } from "./TheScheduleServiceEditConfirm.vue?vue&type=template&id=6d15436a"
import script from "./TheScheduleServiceEditConfirm.vue?vue&type=script&lang=js"
export * from "./TheScheduleServiceEditConfirm.vue?vue&type=script&lang=js"

import exportComponent from "/builds/rclass/new_shlepakov/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__